import { observer } from "mobx-react";
import type React from "react";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { SvgIconReact } from "components/SvgIconReact";
import { TEST_PAGE_ROUTES } from "constants/routes";
import type { DiagnosticTestPagePathParams } from "models/path/path-params";
import { useParams } from "react-router-dom";
import type { DiagnosticTestGroupItemProps } from "./DiagnosticTestGroupItem.model";
import {
  StyledAccordionDiagnosticListItem,
  StyledDiagnosticTestGroupItem,
  StyledPanelRightHeader,
} from "./DiagnosticTestGroupItem.styled";

export const DiagnosticTestGroupItem: React.FC<DiagnosticTestGroupItemProps> = observer(
  ({ item, title = "", groupId }) => {
    const { productId, moduleId } = useParams() as unknown as DiagnosticTestPagePathParams;
    return (
      <StyledDiagnosticTestGroupItem
        to={buildUrlWithPathParams(TEST_PAGE_ROUTES.DIAGNOSTIC_TEST_LIST, {
          productId,
          moduleId,
          groupId,
        })}
      >
        <StyledAccordionDiagnosticListItem
          key={item.id}
          dataCy={`diagnostic-test-list-item-${item.id}`}
          headerPanelRight={
            <StyledPanelRightHeader>
              <SvgIconReact iconName="rightArrow" />
            </StyledPanelRightHeader>
          }
          title={title}
        />
      </StyledDiagnosticTestGroupItem>
    );
  },
);
